import "./Modal.scss"
import React, { ReactNode, useEffect, useState } from "react"
import { Const } from "../../const/const"
import { useMediaQuery } from "react-responsive"
import LoadIndicator from "../../components/loadindicator/LoadIndicator"

interface ModalProps {
    isOpen: boolean
    loading?: boolean
    onClose: () => void
    children: React.ReactNode
    Footer?: React.ReactNode
    useWidth?: boolean
}

interface ModalContentProps {
    children: ReactNode
}

interface ModalFooterProps {
    children: ReactNode
}

interface ModalCompound extends React.FC<ModalProps> {
    Content: React.FC<ModalContentProps>
    Footer: React.FC<ModalFooterProps>
}

const Modal: ModalCompound = ({ isOpen, onClose, children, loading, useWidth }) => {
    const [show, setShow] = useState(isOpen)
    const [visible, setVisible] = useState(false)
    const isSmallScreen = useMediaQuery({ query: "(max-width: 600px)" })

    useEffect(() => {
        if (isOpen) setShow(true)
    }, [isOpen])

    useEffect(() => {
        if (isOpen) {
            setShow(true)
            setTimeout(() => setVisible(true), 10)
        } else {
            setVisible(false)
        }
    }, [isOpen])

    const handleTransitionEnd = () => {
        if (!visible) setShow(false)
    }


    if (!show) return null

    const calculateWidth = (): string => {
        if (!useWidth) {
            return ""
        }

        return isSmallScreen ? "90vw" : "60vw"
    }

    const modalStyle: React.CSSProperties = {
        width: calculateWidth(),
        maxHeight: "90%",
        borderRadius: Const.borderRadiusMedium,
        backgroundColor: "white",
        display: "flex",
        overflow: "hidden",
        flexDirection: "column",
        gap: "1rem",
        boxShadow: "0 4px 8px rgba(0,0,0,0.3)",
    }

    return (
        <div
            className={`modal-overlay ${visible ? "visible" : ""}`}
            onClick={onClose}
            onTransitionEnd={handleTransitionEnd}>
            <div
                className={`modal-content ${visible ? "visible" : ""}`}
                onClick={(e) => e.stopPropagation()}
                style={modalStyle}>
                {children}
                <LoadIndicator glueToParent loading={loading} />
            </div>
        </div>

    )
}

Modal.Content = (props: ModalContentProps) => (
    <div style={{ display: "flex", flexDirection: "column", gap: "1rem", padding: "1rem" }}>
        {props.children}
    </div>
)

Modal.Footer = ({ children }: ModalFooterProps) => (
    <div
        className="modal-footer"
        style={{
            backgroundColor: "white",
            display: "flex",
            justifyContent: "flex-end",
            gap: "0.5rem",
            borderRadius: "18px",
            padding: "0 1rem 1rem 1rem"
        }}>
        {children}
    </div>
)

export default Modal
